module.exports = __webpack_public_path__ + "static/img/pastille.8e8be62c.svg";